export default __webpack_public_path__ + "img/130dab23484949a7794035670d0191da.svg";